export * from './configService';